import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import { FailToastContainer } from 'components/Toast/ToastContainer';
import { CONNECT_OAUTH_KEY, GENERIC_TOAST_ERROR_MESSAGE } from 'config/const';
import { selectIsLoadingAPIRequest } from 'store/ApiClient';
import { connectIntegrationRequest, getIntegrationConnectionsRequest } from 'store/Collections/Integrations';
import { IStore } from 'store/types';
import { IOauthCallbackPayload, IOrganizationConnection } from 'types';
import { Button, Select, Text } from '../../components';
import useConnectIntegration from '../../hooks/useConnectIntegration';
import { storage } from '../../lib';
import * as ActionTypes from '../../store/Collections/Integrations/types';
import { AccessDeniedIcon, ContentContainer, Layout, LoadingHeader, StyledAuthHeader } from './styles';

export const Connect = () => {
  const integration = useConnectIntegration();
  const dispatch = useDispatch();
  const history = useHistory();
  const { code, state, error } = queryString.parse(history.location.search);
  const [organizationConnectionsList, setOrganizationConnectionsList] = useState<IOrganizationConnection[]>();
  const [selectedOrgId, setSelectedOrgId] = useState<string>();
  const isLoading = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, ActionTypes.Integrations.CONNECT_INTEGRATION_REQUEST));
  const integrationOauthState = storage.getItem(CONNECT_OAUTH_KEY);

  useEffect(() => {
    if (integrationOauthState !== state) {
      toast(FailToastContainer({ message: GENERIC_TOAST_ERROR_MESSAGE }), { toastId: 'unexpected-error' });
    }
  }, [integrationOauthState, state]);

  useEffect(() => {
    if (integration) {
      dispatch(getIntegrationConnectionsRequest(integration.name, (response) => setOrganizationConnectionsList(response)));
    }
  }, [integration, dispatch]);

  const mapOptions = () => organizationConnectionsList?.map((orgConnection) => ({ label: orgConnection.organization?.name, value: orgConnection.organization?.id }));

  const handleConnect = () => {
    const body = {
      code,
      state,
      organizationId: selectedOrgId,
    } as IOauthCallbackPayload;
    dispatch(connectIntegrationRequest(integration.name, body, () => history.push(`/connect/${integration.name}/success`)));
  };

  return (
    <Layout>
      {error ? (
        <>
          <StyledAuthHeader logo={<AccessDeniedIcon />} data-cy="auth-header-login-access-denied" title={integration.error.title} subtitle={integration.error.subtitle} />
          <Button label="Continue" onClick={() => history.push(`/connect/${integration.name}/connections`)} />
        </>
      ) : !organizationConnectionsList ? (
        <LoadingHeader />
      ) : (
        <>
          <StyledAuthHeader logo={integration.logo()} data-cy="auth-header-login" title={integration.title} subtitle={integration.subtitle} />
          <ContentContainer>
            <Text fontWeight="semibold">Kickfin Organization to Connect</Text>
            <Select placeholder="Please select" options={mapOptions()} values={[selectedOrgId]} onChange={(selected) => setSelectedOrgId(selected[0]?.value)} data-cy="select" disabled={integrationOauthState !== state} />
          </ContentContainer>
          <Button label="Connect" onClick={handleConnect} disabled={!selectedOrgId} isProcessing={isLoading} />
        </>
      )}
    </Layout>
  );
};
